import { AiOutlineWhatsApp, AiOutlineInstagram, AiOutlineCalendar, AiOutlineShopping, AiOutlineStar } from "react-icons/ai";
import { IoPhonePortraitOutline, IoChevronBack, IoChevronForward, IoLocationOutline, IoMenu, IoClose, IoArrowForward, IoCarOutline } from "react-icons/io5";
import { useEffect, useRef, useState } from "react";

import logo from './assets/logo.jpeg';
import biancaPhoto from './assets/bianca-professional-web.jpeg';

const CURL_WAREHOUSE_REF = 'sca_ref=12494427.OGvbBoi8XD6d';
const SHOPIFY_CDN = 'https://cdn.shopify.com/s/files/1/0272/6048/5711';

const BOOKING_URL = 'https://book.squareup.com/appointments/3wbxy83f3o2jfr/location/3S2C11PDC4FCA/services?staff_id=qrgv6zqjz1125s';
const INSTAGRAM_URL = 'https://www.instagram.com/biahdamascena/';
const WHATSAPP_URL = 'https://wa.me/message/ZE5LIE7WMRP4L1';
const PHONE_URL = 'tel:+18255832939';
const REVIEW_URL = 'https://search.google.com/local/writereview?placeid=ChIJOw058sJvcVMRuS2_wGVll9Q';
const SHOP_URL = 'https://curlwarehouse.com/BiancaD';
const DIRECTIONS_URL = 'https://www.google.com/maps/dir/?api=1&destination=HBR%2BCo%2C%204%2014%20St%20NW%20Unit%20109%2C%20Calgary%2C%20AB%20T2N%201Z4&destination_place_id=ChIJOw058sJvcVMRuS2_wGVll9Q';

const navLinks = [
  { href: '#about', label: 'About' },
  { href: '#services', label: 'Services' },
  { href: '#reviews', label: 'Reviews' },
  { href: '#work', label: 'My work' },
  { href: '#products', label: 'Products' },
  { href: '#contact', label: 'Contact' },
];

const services = [
  {
    title: 'Textured cuts',
    description: 'Specialized cutting for textured hair, from wavy to curly and coily.',
  },
  {
    title: 'Balayage & blonding',
    description: 'Balayage and blonding across various natural levels.',
  },
  {
    title: 'Custom cuts',
    description: 'Custom looks that fit your lifestyle and reflect your personality.',
  },
  {
    title: 'Hair Botox',
    description: 'Treatments that keep your hair sustainable and healthy.',
  },
  {
    title: 'Extensions',
    description: 'Whether you\'re looking for a dramatic transformation or a routine touch-up.',
  },
];

const reviews = [
  {
    name: 'Camila Stankevicius',
    url: 'https://share.google/KGpb2JzN3S6CwBJAy',
    text: 'Bianca did an amazing job with my balayage! She was very attentive, professional, and made sure I was comfortable throughout the whole appointment. She took the time to understand exactly what I wanted, and the results exceeded my expectations. Highly recommend! 🥰',
  },
  {
    name: 'Beatriz Kalfels',
    url: 'https://share.google/c7k0hqfotty80NvTm',
    text: 'I had a wonderful experience with Bianca! She truly specializes in curly hair and did an incredible job cutting my daughter’s curls. What impressed me most was her technique — she cut the hair dry, carefully shaping each curl individually rather than cutting it wet and hoping for the best. The attention to detail and understanding of curly hair made such a difference. The final result was absolutely beautiful. My daughter’s curls have never looked so defined, balanced, and full of life. We couldn’t be happier with the cut and will definitely be coming back. Highly recommend Bianca to anyone looking for a stylist who genuinely understands curls!',
  },
  {
    name: 'Caylenne Deverson',
    url: 'https://share.google/iZGF28uUKuqjLMMyf',
    text: 'Wish I could leave 10 stars. Bianca was so attentive and knowledgeable. I felt like a star from the moment I walked in. Everyone you interacted with was so lovely. The salon itself is on a great location with easy parking. So happy with my hair treatment and cut. I did do a quite extreme haircut for me and I trusted Bianca to work her magic and that she did. She made sure to figure out what my vision was along with what would work with my face shape. I will be back! Cannot say enough about this salon.',
  },
  {
    name: 'Katarzyna Stercz',
    url: 'https://share.google/KpcqqdCPzg7EdyJ4t',
    text: 'Super stoked about my hair transformation made by Bianca! I went from full on blonde (of 11 years of bleaching) to my natural brown hair and couldn’t be happier about the results! Such huge hair color transformation can be scary but I was being explained everything every step of the way which reassured me that I’m in good hands, and the outcome confirms that. I can definitely recommend Bianca!',
  },
  {
    name: 'Monny GM',
    url: 'https://share.google/9d2LJYKBpD05ChYBD',
    text: 'I\'ve finally found someone who truly gets my curly hair. Bianca is a fantastic hairdresser; she really listens, gives great advice, and provides outstanding customer service. Plus, there was zero waiting time, which was awesome!',
  },
];

const favoriteProducts = [
  {
    handle: 'bounce-curl-define-edgelift-styling-brush',
    brand: 'Bounce Curl',
    title: 'Define EdgeLift Brush',
    image: `${SHOPIFY_CDN}/files/Define_EdgeLift_Brush_Teal_Main_1080x1080_d4184b01-b928-4db4-86f6-bfd31ca28e14.webp?v=1770229353`,
  },
  {
    handle: 'k18-leave-in-molecular-repair-hair-mask',
    brand: 'K18',
    title: 'Leave-in Molecular Repair Hair Mask',
    image: `${SHOPIFY_CDN}/files/k18_mask.jpg?v=1737497465`,
  },
  {
    handle: 'k18-peptide-prep-detox-shampoo',
    brand: 'K18',
    title: 'Peptide Prep Detox Shampoo',
    image: `${SHOPIFY_CDN}/files/K18-Peptide-Prep-Detox-Shampoo-8.5oz-RKB-KBH-CPPDS08--500x500.jpg?v=1737497098`,
  },
  {
    handle: 'recoil-curl-activator',
    brand: 'AG Hair',
    title: 'Re:coil Curl Activator',
    image: `${SHOPIFY_CDN}/products/COIL6.jpg?v=1762530994`,
  },
  {
    handle: 'innersense-organic-beauty-i-create-hold-styling-gel',
    brand: 'Innersense',
    title: 'I Create Hold Styling Gel',
    image: `${SHOPIFY_CDN}/products/I-Create-Hold-10oz-Innersense-Organic-Beauty-600x600.jpg?v=1762530675`,
  },
  {
    handle: 'pop-up-diffuser',
    brand: 'Curl Keeper',
    title: 'Pop-Up Silicone Curl Diffuser',
    image: `${SHOPIFY_CDN}/products/CurlKeeperDiffuser.jpg?v=1762530700`,
  },
];

function App() {
  const productsRef = useRef(null);
  const reviewsRef = useRef(null);

  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    const onKey = (e) => e.key === 'Escape' && setMenuOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [menuOpen]);

  const scrollCarousel = (ref, direction) => {
    const list = ref.current;
    const item = list.firstElementChild;
    const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
    list.scrollBy({ left: direction * (item.offsetWidth + gap), behavior: 'smooth' });
  };

  return (
    <>
      <header className={`header${scrolled ? ' header--scrolled' : ''}${menuOpen ? ' header--open' : ''}`}>
        <div className="header_inner">
          <a className="header_brand" href="#top" onClick={() => setMenuOpen(false)}>
            Bia <span>Damascena</span>
          </a>

          <nav className="header_nav" aria-label="Main">
            <ul>
              {navLinks.map(({ href, label }) => (
                <li key={href}><a href={href} onClick={() => setMenuOpen(false)}>{label}</a></li>
              ))}
            </ul>
            <a className="btn btn--dark header_nav_book" href={BOOKING_URL} target="_blank" rel="noreferrer">Book now</a>
          </nav>

          <div className="header_actions">
            <a className="btn btn--dark btn--small header_book" href={BOOKING_URL} target="_blank" rel="noreferrer">Book</a>
            <button
              className="header_toggle"
              type="button"
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((open) => !open)}
            >
              {menuOpen ? <IoClose /> : <IoMenu />}
            </button>
          </div>
        </div>
      </header>

      <main id="top">
        <section className="hero">
          <div className="hero_inner">
            <div className="hero_brand">
              <img className="hero_logo" src={logo} alt="Bia Damascena logo" width="1024" height="683" />
              <h1 className="sr-only">Bia Damascena - Hairstylist in Calgary, AB</h1>
              <p className="hero_script">Hairstylist</p>
              <p className="hero_meta">Calgary, AB &middot; HBR+Co</p>
              <p className="hero_lead">Making you feel as good as you look and discovering your hair potential.</p>

              <div className="hero_ctas">
                <a className="btn btn--dark" href={BOOKING_URL} target="_blank" rel="noreferrer">
                  <AiOutlineCalendar /> Book an appointment
                </a>
                <a className="btn btn--outline" href="#work">See my work</a>
              </div>
            </div>

            <div className="hero_photo">
              <img src={biancaPhoto} alt="Bianca Damascena, hairstylist in Calgary" width="689" height="1000" />
              <div className="hero_badge">
                <strong>10+</strong>
                <span>years behind<br />the chair</span>
              </div>
            </div>
          </div>
        </section>

        <section className="about" id="about">
          <div className="container about_inner">
            <div className="section_head about_head">
              <p className="eyebrow">About me</p>
              <h2>Hi, I'm Bianca</h2>
              <p className="about_lead">I'm passionate about making you feel as good as you look and discovering your hair potential!</p>
            </div>

            <div className="about_text">
              <p>With over 10 years of experience behind the chair, I specialize in cutting textured hair from wavy to curly and coily. Balayage, blonding across various natural levels, custom cuts, hair Botox treatments, and extensions are my game.</p>
              <p>My goal is to create custom looks that fit your lifestyle. I don’t just follow hair trends; I know that your hair has to reflect your personality, and I’m here to help you achieve that!</p>
              <blockquote className="about_quote">
                For me, hairdressing isn't just about technical skills; it's about connection.
              </blockquote>
              <p>My mission is to understand your hair goals and bring that vision to life in a way that is sustainable and healthy for your hair. Whether you're looking for a dramatic transformation, a routine touch-up, or just a relaxing escape in my chair, I'm here to provide a welcoming, inclusive experience.</p>
              <p>When I'm not in the salon, you can usually find me binge-watching a TV show, exploring local restaurants, or traveling (and planning my next trip, haha!).</p>
              <p className="about_sign">I can't wait to welcome you to HBR+Co and create some hair magic together!</p>
            </div>
          </div>
        </section>

        <section className="services" id="services">
          <div className="container">
            <div className="section_head">
              <p className="eyebrow">What I do</p>
              <h2>Services</h2>
            </div>

            <ul className="services_list">
              {services.map(({ title, description }, index) => (
                <li key={title} className="services_item">
                  <span className="services_num">{String(index + 1).padStart(2, '0')}</span>
                  <h3>{title}</h3>
                  <p>{description}</p>
                </li>
              ))}
              <li className="services_item services_item--cta">
                <h3>Looking for something else?</h3>
                <p>See all services available and book online.</p>
                <a className="btn btn--light" href={BOOKING_URL} target="_blank" rel="noreferrer">
                  See all services <IoArrowForward />
                </a>
              </li>
            </ul>
          </div>
        </section>

        <section className="reviews" id="reviews">
          <div className="container">
            <div className="section_head">
              <p className="eyebrow">Kind words</p>
              <h2>Client reviews</h2>
              <p className="reviews_summary">
                <span className="reviews_stars" aria-hidden="true">{'★'.repeat(5)}</span>
                5-star reviews on Google
              </p>
            </div>

            <div className="carousel">
              <button className="carousel_arrow" type="button" aria-label="Previous reviews" onClick={() => scrollCarousel(reviewsRef, -1)}>
                <IoChevronBack />
              </button>

              <ul className="carousel_list reviews_list" ref={reviewsRef}>
                {reviews.map(({ name, url, text }) => {
                  const isLong = text.length > 260;
                  return (
                    <li key={name} className="carousel_item">
                      <figure className="review">
                        <span className="reviews_stars" role="img" aria-label="5 out of 5 stars">{'★'.repeat(5)}</span>
                        <blockquote className={`review_text${isLong ? ' review_text--clamped' : ''}`}>
                          <p>{text}</p>
                        </blockquote>
                        {isLong && (
                          <a className="review_more" href={url} target="_blank" rel="noreferrer" aria-label={`Read ${name}'s full review on Google`}>
                            Read full review <IoArrowForward />
                          </a>
                        )}
                        <figcaption className="review_author">
                          <span className="review_avatar" aria-hidden="true">{name.charAt(0)}</span>
                          <span>
                            <cite>{name}</cite>
                            <a href={url} target="_blank" rel="noreferrer">Google review</a>
                          </span>
                        </figcaption>
                      </figure>
                    </li>
                  );
                })}
              </ul>

              <button className="carousel_arrow" type="button" aria-label="Next reviews" onClick={() => scrollCarousel(reviewsRef, 1)}>
                <IoChevronForward />
              </button>
            </div>

            <div className="section_foot">
              <a className="btn btn--outline" href={REVIEW_URL} target="_blank" rel="noreferrer">
                <AiOutlineStar /> Leave me a Google review
              </a>
            </div>
          </div>
        </section>

        <section className="gallery" id="work">
          <div className="container">
            <div className="section_head">
              <p className="eyebrow">Portfolio</p>
              <h2>My work</h2>
            </div>

            <div className="gallery_feed">
              <behold-widget feed-id="GwFuydZom6LFxpgy2RwV" />
            </div>

            <div className="section_foot">
              <a className="btn btn--outline" href={INSTAGRAM_URL} target="_blank" rel="noreferrer">
                <AiOutlineInstagram /> See more on Instagram
              </a>
            </div>
          </div>
        </section>

        <section className="products" id="products">
          <div className="container">
            <div className="section_head">
              <p className="eyebrow">Shop</p>
              <h2>My favorite products</h2>
            </div>

            <div className="products_carousel">
              <button className="products_arrow" type="button" aria-label="Previous products" onClick={() => scrollCarousel(productsRef, -1)}>
                <IoChevronBack />
              </button>

              <ul className="products_list" ref={productsRef}>
                {favoriteProducts.map(({ handle, brand, title, image }) => (
                  <li key={handle} className="products_item">
                    <a href={`https://curlwarehouse.com/products/${handle}?${CURL_WAREHOUSE_REF}`} target="_blank" rel="sponsored noreferrer">
                      <div className="products_image">
                        <img src={`${image}&width=400`} alt={`${brand} ${title}`} loading="lazy" />
                      </div>
                      <p className="products_brand">{brand}</p>
                      <p className="products_title">{title}</p>
                      <span className="products_cta">Shop</span>
                    </a>
                  </li>
                ))}
              </ul>

              <button className="products_arrow" type="button" aria-label="Next products" onClick={() => scrollCarousel(productsRef, 1)}>
                <IoChevronForward />
              </button>
            </div>

            <div className="section_foot">
              <a className="btn btn--outline" href={SHOP_URL} target="_blank" rel="sponsored noreferrer">
                <AiOutlineShopping /> Shop my favorite curl products
              </a>
            </div>
          </div>
        </section>

        <section className="visit" id="contact">
          <div className="container visit_inner">
            <div className="visit_info">
              <div className="section_head">
                <p className="eyebrow">Visit me</p>
                <h2>Contact</h2>
              </div>

              <div className="visit_columns">
                <div className="visit_card visit_details">
                  <p className="visit_title">Location</p>
                  <div className="visit_block">
                    <IoLocationOutline />
                    <div>
                      <address className="visit_address">
                        HBR+Co<br />
                        4 14 St NW, Unit 109<br />
                        Calgary, AB T2N 1Z4
                      </address>
                      <a className="visit_link" href={DIRECTIONS_URL} target="_blank" rel="noreferrer">
                        Get directions <IoArrowForward />
                      </a>
                    </div>
                  </div>

                  <div className="visit_block">
                    <IoCarOutline />
                    <div>
                      <p className="visit_label">Free parking</p>
                      <p className="visit_note">Free parking is located on the south side of the building, in front of Harmony Acupuncture. The parking lot can be accessed from either direction on 14 Street, and there is a turning lane to cross 14 Street.</p>
                    </div>
                  </div>
                </div>

                <div className="visit_card visit_actions">
                  <p className="visit_title">Get in touch</p>

                  <ul className="contact_list">
                    <li>
                      <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer">
                        <AiOutlineInstagram /><span>@biahdamascena</span>
                      </a>
                    </li>
                    <li>
                      <a href={PHONE_URL}>
                        <IoPhonePortraitOutline /><span>+1 825 583 2939</span>
                      </a>
                    </li>
                    <li>
                      <a href={WHATSAPP_URL} target="_blank" rel="noreferrer">
                        <AiOutlineWhatsApp /><span>Bia Damascena</span>
                      </a>
                    </li>
                    <li>
                      <a href={REVIEW_URL} target="_blank" rel="noreferrer">
                        <AiOutlineStar /><span>Leave me a Google review</span>
                      </a>
                    </li>
                  </ul>

                  <a className="btn btn--dark btn--block visit_book" href={BOOKING_URL} target="_blank" rel="noreferrer">
                    <AiOutlineCalendar /> Book an appointment
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container footer_inner">
          <p className="footer_brand">Bia <span>Damascena</span></p>
          <ul className="footer_social">
            <li><a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" aria-label="Instagram"><AiOutlineInstagram /></a></li>
            <li><a href={WHATSAPP_URL} target="_blank" rel="noreferrer" aria-label="WhatsApp"><AiOutlineWhatsApp /></a></li>
            <li><a href={PHONE_URL} aria-label="Call"><IoPhonePortraitOutline /></a></li>
          </ul>
          <p className="footer_copy">&copy; {new Date().getFullYear()} Bia Damascena &middot; Hairstylist in Calgary, AB</p>
        </div>
      </footer>
    </>
  );
}

export default App;
